"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedfreeshipping = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedfreeshipping` : '') + (description ? ` desc-brandedfreeshipping` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedfreeshipping"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedfreeshipping"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M52.66 4.04v44.45a4.04 4.04 0 0 1-4.04 4.04H4.18a4.02 4.02 0 0 1-3.73-2.47l-.1-.26a2.04 2.04 0 0 1-.08-.27l-.06-.28a3.71 3.71 0 0 1-.07-.77V4.05A4.04 4.04 0 0 1 4.18 0h44.44a4.76 4.76 0 0 1 .59.05c.28.04.56.11.83.21l.26.11.39.2.19.12a4 4 0 0 1 1.78 3.35Z",
    fill: "#F9D29F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.06.9C39.12 22.27 21.98 39.51 0 49.75A4.06 4.06 0 0 0 3.64 53h.51l44.49-.5c4 0 4-3.5 4-4.5L52.5 3.82C52.5 2.5 52 1.5 51.06.9Z",
    fill: "#EDBC7C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 18V0h16v18l-4-5-4 4-3.5-4-4.5 5Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.25 31.1h4.69v2.88h-4.7v4.2h-3.1V26h8.47v2.92H9.25v2.18Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.7 34.3h-.56v3.87h-3.1V26h4.85c2.51 0 4.45 1.15 4.52 4 0 2.25-.91 3.52-2.4 3.99l3.33 4.17H22.5l-2.82-3.87.01.01Zm1.25-2.64c1.94 0 1.94-2.78 0-2.78h-1.8v2.78h1.8Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.24 30.79h4.94v2.66h-4.94v1.82h5.36v2.91h-8.47V26.01h8.47v2.89h-5.36v1.89Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.35 30.79h4.93v2.66h-4.93v1.82h5.35v2.91h-8.47V26.01h8.47v2.89h-5.35v1.89Z",
    fill: "#CC0058"
  }));
};
var _default = exports.default = brandedfreeshipping;